<template><div>
    <Tabs :animated="false">
        <Tab-pane v-bar="{preventParentScroll: true,scrollThrottle: 30}" :style="{height: `${height}px`}" class="proptab" label="属性设置">
        	<div><div v-if="ispage" style="padding-bottom: 70px;overflow: hidden;">
        		<page-set :pageinfo="options"></page-set>
        	</div>
        	<div v-else style="padding-bottom: 70px;overflow: hidden;">
    			<mod-property :options="options" :attrs="attrs" :key="attrs.type"></mod-property>
				<div class="content" v-if="attrs.parent && !isformel" style="padding-left:10px;">
					<div class="form-group clearFix">
						<label class="option-alias">位置</label>
						<div class="rightbox">
							<span class="subtitle">X:</span>
							<InputNumber class="subinp" size="large" v-model="attrs.left"></InputNumber>
							<span class="subtitle">Y:</span>
							<InputNumber class="subinp" size="large" v-model="attrs.top"></InputNumber>
						</div>
					</div>
					<div class="form-group clearFix">
						<label class="option-alias">尺寸</label>
						<div class="rightbox">
							<span class="subtitle">宽:</span>
							<InputNumber :min="isAbsMedia?20:0" class="subinp" size="large" v-model="attrs.width"></InputNumber>
							<span class="subtitle">高:</span>
							<InputNumber :min="isAbsMedia?20:0" class="subinp" size="large" v-model="attrs.height"></InputNumber>
						</div>
					</div>
				</div>
				<div v-if="!ispage && ['media','mtitle','buttons'].findIndex(c => c == attrs.type) > -1" style="padding-left:10px;">
					<div class="form-group clearFix">
						<label class="option-alias">点击事件</label>
						<Pagelinker :attrs="attrs" v-model="attrs.childprop.modclick" :inner="isInner" style="line-height: 36px;" />
					</div>

					<div class="form-group clearFix" v-if="showDetailId">
						<label class="option-alias">链接到</label>
						<Select v-model="attrs.childprop.modclick.param.pagevalue" :disabled="detail_pages.length ? false : true"
						 :placeholder="detail_pages.length ? '请选择' : `请先创建「${detailType}」页`" size="large" class="option-control fl"
						 :placement="pagePlacement" style="width: 200px;">
							<Option v-for="page in detail_pages" :value="page.id" :key="page.id">{{page.name}}</Option>
						</Select>
					</div>

					<div class="form-group clearFix"  v-if="showDetailId && attrs.childprop.modclick.param.pagevalue">
						<label class="option-alias">数据源</label>
						<Input :disabled="true" :value="dataSourceAlias"
						 class="option-control fl special" size="large" style="width: 200px;">
							<span slot="prepend">已选择</span>
							<span slot="append" @click="dialogShow = true">选择</span>
						</Input>
					</div>

					<div class="form-group clearFix" v-if="isPageDirectShow">
						<label class="option-alias">跳转方式</label>
						<RadioGroup v-model="linkredirect" style="line-height: 36px;">
							<Poptip trigger="hover">
								<Radio label="0">新页面</Radio>
								<div slot="content">
									<p>保留当前页面且有返回键</p>
									<p style="color: #f00;">注：目前页面路径只能最多十层</p>
								</div>
							</Poptip>
							<Poptip trigger="hover">
								<Radio label="1">原页面</Radio>
								<div slot="content">
									<p>关闭当前页面且无返回键</p>
									<p style="color: #ff;">注：页面路径无限制</p>
								</div>
							</Poptip>
						</RadioGroup>
					</div>
				</div>
        	</div></div>
        </Tab-pane>
        <Tab-pane v-bar="{preventParentScroll: true,scrollThrottle: 30}" :style="{height: `${height}px`}" class="proptab" label="样式设置"><div><div style="padding-bottom: 70px;overflow: hidden;">
			<Collapse v-model="panelId" v-if="!nostyle" class="set_box-container" style="width:105% !important;">
				<Panel name="bg" class="set_box">
					<b class="mark_choose"></b>背景设置
					<div slot="content">
						<div class="form-group clearFix input-reset">
							<label class="control-label tex-left tex-width fl">背景图片：</label>
							<div class="fl bg-container" :style="{'background-color': glbstyle['background-color'],'background-image': parseBgimg,
							'background-repeat': glbstyle['background-repeat'],'background-position': glbstyle['background-position']}"></div>
							<div class="col-sm bg-col-sm" style="margin-left:8px;width:60px;"><div>
								<Button @click="choosePic('bgimg')" size="small" type="primary" class="bg-col-sm-btn" style="width:50px;">上传</Button>
								<Button @click="glbstyle['background-image']='none'" size="small" class="bg-col-sm-btn" style="width:50px;">移除</Button>
							</div></div>
						</div>
						<div class="form-group clearFix">
							<label class="control-label tex-left tex-width fl">背景颜色：</label>
							<div class="col-sm">
								<ColorPicker2 size="large" v-model="glbstyle['background-color']" />
							</div>
						</div>
						<div class="form-group clearFix input-reset form-sort">
							<label class="control-label tex-left tex-width fl">背景重复：</label>
							<div class="col-sm propbgrepeat">
								<RadioGroup v-model="glbstyle['background-repeat']" type="button">
									<Radio label="repeat" class="t1">平铺</Radio>
									<Radio label="repeat-x" class="t2">横向平铺</Radio>
									<Radio label="repeat-y" class="t3">纵向平铺</Radio>
									<Radio label="no-repeat" class="t4">不平铺</Radio>
								</RadioGroup>
							</div>
						</div>
						<div class="form-group clearFix">
							<label class="control-label tex-left tex-width fl label-height">对齐位置：</label>
							<div class="col-sm" style="width:66px">
								<div class="position-set-block">
									<span :class="{on: glbstyle['background-position'] == pos}" v-for="pos in bgpos" @click="glbstyle['background-position'] = pos"><span class="mark"></span></span>
								</div>
							</div>
						</div>
					</div>
				</Panel>
				<Panel name="gborder" v-if="!ispage && !nostyle" class="set_box">
					<b class="mark_choose"></b>边框设置
					<div slot="content">
						<div class="form-group clearFix">
							<label class="control-label tex-left tex-width fl">边框样式：</label>
							<div class="col-sm">
								<Select size="large" :transfer="true" v-model="glbstyle['border-style']" style="width:200px" placement="top">
									<Option v-for="item in borderstyle" :value="item.value" :key="item.value">{{item.label}}</Option>
								</Select>
							</div>
						</div>
						<div class="form-group clearFix">
							<label class="control-label tex-left tex-width fl">边框粗细：</label>
							<div class="col-sm">
								<InputNumber size="large" v-model="glbstyle['border-width']" :max="10" :min="0"></InputNumber>
							</div>
						</div>
						<div class="form-group clearFix">
							<label class="control-label tex-left tex-width fl">边框颜色：</label>
							<div class="col-sm">
								<ColorPicker2 size="large" v-model="glbstyle['border-color']" />
							</div>
						</div>
						<div class="form-group clearFix">
							<label class="control-label tex-left tex-width fl">边框圆角：</label>
							<div class="col-sm">
								<InputNumber size="large" v-model="glbstyle['border-radius']" :min="0"></InputNumber>
							</div>
						</div>
					</div>
				</Panel>
			</Collapse>
			<component :is="compStyle" :options="options" :attrs="attrs"></component>
        </div></div></Tab-pane>
    </Tabs>
    <product-selector :isradio="isradio" :attrs="attrs" v-if="dialogShow"></product-selector>
</div></template>

<script>
import Vue from 'vue';
import jGlobal from '@/global';
import Mods from '@/common/mods';
import EventBus from '@/common/events';
import ColorPicker2 from '@/components/colorpicker';
import ModProperty from '@/components/modproperty';
import Pagelinker from '@/components/pagelinker';
import PageSet from '@/components/pageset';
import defaultImg from '@/assets/prevbg.gif';
import ProductSelector from '@/wxplugins/product_list/product_selector';

Vue.component('font-weight', {
	template: '<i @click="setVal" :class="[\'fontIcon\',\'icon-jiacu\',{on: value==\'bold\'}]" title="粗体"></i>',
	props: {value: String},
	methods: {
		setVal (){
			this.$emit('input', (this.value == 'normal')?'bold':'normal')
		}
	}
});
Vue.component('text-decoration', {
	template: '<i @click="setVal" :class="[\'fontIcon\',icnClastr,{on: isActived}]" :title="icnTitle"></i>',
	props: {value: String,accept: String},
	computed: {
		icnClastr (){
			return 'icon-' + (this.accept?'fontstrikethrough':'xiahuaxian')
		},
		isActived (){
			return this.value == (this.accept||'underline')?true:false
		},
		icnTitle (){
			return this.accept?'中划线':'下划线'
		}
	},
	methods: {
		setVal (){
			this.$emit('input', (this.value == 'none')?(this.accept||'underline'):'none')
		}
	}
});
Vue.component('font-style', {
	template: '<i @click="setVal" :class="[\'fontIcon\',\'icon-xieti\',{on: value==\'italic\'}]" title="斜体"></i>',
	props: {value: String},
	methods: {
		setVal (){
			this.$emit('input', (this.value == 'normal')?'italic':'normal')
		}
	}
});
Vue.component('inline-linker', {
	template: '<Select :value="value" :size="size" :placement="placement" :placeholder="placeholder" :filterable="filterable" @on-change="setVal">\
		<Option value="">请选择</Option>\
		<!--Option value="ucenter">我的</Option-->\
		<Option v-for="d in data" :value="d.id" :key="d.id">{{d.name||`未命名(${d.id})`}}</Option>\
		</Select>',
	computed: {
		isLevel4 (){
      const gparams = WPCommon.getGlobalParams();
			return gparams.wxapp_level == '4' ? true : false
		}
	},
	props: {
		value: [String,Number], data: [Array,Object], size: String,
		filterable: {type: Boolean, default: false},
		placement: {type: String, default: 'bottom'},
		placeholder: {type: String, default: '请选择'},
	},
	methods: {
		setVal (newval){
			this.$emit('input', newval)
		}
	}
});

let maxw = 375,
aspectFit = (maxh, imgw, imgh, maxw = 375) => {
	let new_imgw = 0, new_imgh = 0;
	// 保持纵横比缩放图片，使图片的长边能完全显示出来
	// 即可以完整地将图片显示出来 - aspectFit
	if (imgw >= imgh) {
		new_imgw = maxw;
		new_imgh = maxw * imgh / imgw;
		if (new_imgh > maxh) {
			new_imgh = maxh;
			new_imgw = maxh * imgw / imgh
		}
	} else {
		new_imgh = maxh;
		new_imgw = maxh * imgw / imgh;
		if (new_imgw > maxw) {
			new_imgw = maxw;
			new_imgh = maxw * imgh / imgw
		}
	}
	let m_top = maxh > new_imgh ? Math.round((maxh - new_imgh) / 2) : 0;
	let m_left = maxw > new_imgw ? Math.round((maxw - new_imgw) / 2) : 0;
	return {"width": new_imgw,"height": new_imgh,"mtop": m_top,"mleft": m_left}
};
Vue.directive('aspectfit', {
	inserted (el){
		let maxh = parseInt($(el).parent().css('height'));
		$(el).css("visibility", 'hidden').on("load", function(e){
			let img = new Image();
			img.src = $(el)[0].currentSrc;
			let imgWidth = img.width, imgHeight = img.height;
			maxw = $(this).parent().width();
			let size = aspectFit(maxh, imgWidth, imgHeight, maxw),
			plugin = $(this).closest('.cstlayer').attr('type');
			if (plugin != 'product_list') size.mleft = 0;
			$(this).css({"display": 'inline',"visibility": '',"margin-top": `${size.mtop}px`,
				"margin-left": `${size.mleft}px`,"width": `${size.width}px`,"height": `${size.height}px`})
		})
	},
	update (el){
		let plugin = $(el).closest('.cstlayer').attr('type');
		if (plugin == 'product_list') return false;
		let maxh = parseInt($(el).parent().css('height'));
		$(el).width('auto').height('auto');

		let size = aspectFit(maxh, $(el).width(), $(el).height());
		$(el).css({"width": `${size.width}px`,"height": `${size.height}px`,"margin-top": `${size.mtop}px`})
	}
});

let initProperty = function(isinit = false){
	let _type = this.attrs.type,
	curpage = jGlobal.getCurPage();

	this.nostyle = false;
	if (_type.toLowerCase() == 'page') {
		//this.panelId = 'bg';
		this.ispage = true;
		!isinit && (this.options = curpage.pageinfo || {})
	} else {
		//this.panelId = '';
		this.ispage = false;
		!isinit && (this.pages = curpage.pages);
		this.options = Mods.get_plugin_options(_type)
	}

	// Set 'background/border-style'
	let bgopt = {
		'background-image': 'none',
		'background-color': 'transparent',
		'background-repeat': 'repeat',
		'background-position': 'top left'
	}, oldval = this.options['s_params'];
	if (! this.ispage) {
		oldval = this.attrs.childprop.globalstyle || this.attrs.globalstyle;
		bgopt = Object.assign(bgopt, {'border-color': 'transparent',
			'border-style': 'none','border-width': 0,'border-radius': 0})
	}
	if (! $.isPlainObject(oldval)) oldval = {};
	this.glbstyle = $.extend(true, {}, bgopt, oldval);
	// for 'styles - component'
	let modstyles = Mods.get_plugin_styles(_type);
	if (!modstyles) {this.compStyle = '';return false}
	this.compStyle = `styles_${_type}`;
	this.$options.components[this.compStyle] = modstyles
};

let initDetailLink = function(){
	let modclicks = this.attrs.childprop.modclick;
	if (! modclicks) {
		this.$set(this.attrs.childprop, 'modclick', {
			"type": 'none',"param": {"type": '',"value": ''}
		})
	}

	this.initDetail = true;
	if (this.attrs.type == 'buttons') {
		this.pagePlacement = 'bottom'
	} else this.pagePlacement = 'top';

	// for '链接至商品列表/详情'
	this.linkToProductPage(modclicks.param.type)
};

export default
{
	name: 'Property',
	data (){
		return {
			ispage: false,
			isInner: true,
			pages: [],
			options: {},
			glbstyle: {},
			borderstyle: [
				{value: 'none',label: '无'},
				{value: 'solid',label: '实线'},
				{value: 'dotted',label: '点线'},
				{value: 'dashed',label: '虚线'}
			],
			bgpos: ['top left','top center','top right',
				'center left','center center','center right',
				'bottom left','bottom center','bottom right'],
			compStyle: '',
			panelId: 'bg',
			detail_pages: [],
			showDetailId: false,
			detailType: '',
			isradio: true,
			dialogShow: false,
			initDetail: false,
			pagePlacement: 'top',
		}
	},
	props: ['attrs','height'],
	created (){
		initProperty.apply(this, [true]);
		let curpage = jGlobal.getCurPage();
		if (this.attrs.type.toLowerCase() == 'page') {
			this.options = curpage.pageinfo || {};
			this.glbstyle = Object.assign(this.glbstyle, this.options['s_params'])
		} else this.pages = curpage.pages;
		
		this.$watch('glbstyle', res => {
			if (this.ispage) {
				let oldval = {};
				if (this.options['s_params']) oldval = JSON.parse(JSON.stringify(this.options['s_params']));
				let newval = $.extend(true, {}, oldval, res);
				this.$set(this.options, 's_params', newval)
			} else {
				let layerid = this.attrs.id,
				curpage = jGlobal.getCurPage(),
				i = curpage.modinfo.findIndex(v => v.id == layerid);
				if (i >= 0) curpage.modinfo[i]['globalstyle'] = res
			}
		}, {deep: true});

		this.$watch('attrs.childprop.modclick.param.type', (newtype, oldtype) => {
			// for '链接至商品列表/详情'
			this.linkToProductPage(newtype)
			// for '重置'
			if (oldtype && oldtype != newtype) {
				this.attrs.childprop.modclick.param.pagevalue = ''
			}
		}, {deep: true});

		this.$watch('attrs.childprop.modclick.param.pagevalue', res => {
			if (res != '') return false;
			this.attrs.childprop.modclick.param.idsvalue = '';
			this.attrs.childprop.modclick.param.title = ''
		})
	},
	watch: {
		'attrs.id' (layerid){
			initProperty.apply(this);
			// for 'delete' shortcut key
			window.actived_layerid = layerid
		}
	},
	computed: {
		dataSourceAlias (){
			let _param = this.attrs.childprop.modclick.param;
			return (_param.type == 'product_list') ? `${_param.idsvalue.length}个` : _param.title
		},
		isPageDirectShow (){
			let modclick = this.attrs.childprop.modclick;
			if (! modclick) return false;

			let linktype = modclick.type, param = modclick.param;
			if (linktype == 'page' && $.trim(param.value).length) return true;
			else if (linktype == 'func' && this.showDetailId
				&& $.trim(param.pagevalue).length) return true;
			return false
		},
		linkredirect: {
			get (){
				let param = this.attrs.childprop.modclick.param;
				return (param.redirect == '1') ? '1' : '0'
			},
			set (newval){
				let param = this.attrs.childprop.modclick.param;
				this.$set(param, 'redirect', newval)
			}
		},
		parseBgimg (){
			let bgimg = this.glbstyle['background-image'];
			if (bgimg == 'none') bgimg = defaultImg;
			return /^url\(/i.test(bgimg) ? bgimg : `url(${bgimg})`
		},
		isAbsMedia (){
			return (this.attrs.type == 'media') ? true : false
		},
		isformel (){
			return /^form_/i.test(this.attrs.type)
		}
	},
	components: {ColorPicker2, Pagelinker, PageSet, ModProperty, ProductSelector},
	methods: {
		choosePic (idx){
			EventBus.$emit("show_filemanager", true, res => {
				if (idx == 'bgimg') this.glbstyle['background-image'] = res
				else this.$set(vm.attrs.childprop, idx, res)
			}, 'pic')
		},
		linkToProductPage (curmod){
			let showDetailId = true, action = '';
			switch (curmod) {
				case 'product_detail':
					action = 'prdetail';
					this.detailType = '产品详情';
					break;
				case 'product_list':
					action = 'prdlist';
					this.detailType = '产品列表';
					break;
				default:
					action = '';curmod = '';
					showDetailId = false;
					break;
			}
			
			if (curmod.length > 0 && action.length > 0) {
				jGlobal.xhrPost(`page/${action}`, null, res => {
					if (res.result != 'OK') {
						console.error('尚未找到匹配的数据源或产品已下架');
						return false
					}

					this.detail_pages = res.data || [];
					if (this.detail_pages.length > 0) {
						this.isradio = (curmod == 'product_list') ? false : true;
						EventBus.$on("prdselector_close", () => this.dialogShow = false)
					}
				}, err => console.error(err))
			}

			this.showDetailId = showDetailId
		}
	},
	directives: {
		adapt: {
			inserted (el){
				$(el).css("visibility", 'hidden');
				$(el).on("load", function(event){
					let img = event.target,
					w, h, t, W = 102, H = 108,
					cw = img.width, ch = img.height;
					if (cw == 0 || ch == 0) {
						let imgobj = this.items[index] || {};
						cw = parseFloat(imgobj.width);
						ch = parseFloat(imgobj.height)
					}
					if (cw > ch * W / H) {
						w = Math.min(W, cw);
						h = (ch * w) / cw;
						t = (H - h) / 2
					} else {
						h = Math.min(H, ch);
						w = (cw * h) / ch;
						t = (H - h) / 2
					}

					$(img).css({"width": `${w}px`,height: `${h}px`,top: `${t}px`,'visibility': ''})
					 .fadeIn("slow", function(){$(this).siblings('.loading').remove()})
				})
			}
		},
	},
}
</script> 

<style type="text/css">
.ivu-collapse {border: none!important;}
.ivu-switch-disabled {background: #f9f9f9 !important;border-color: #f9f9f9 !important;}
.ivu-collapse > .ivu-collapse-item > .ivu-collapse-header {padding-left: 10px!important;}
.ivu-radio-group-button .ivu-radio-wrapper:after, .ivu-radio-group-button .ivu-radio-wrapper:before {width: 0;}
.propanel .clearFix:after {content: '';clear: both;width: 0;height: 0;display: block;}
.propanel .proptab {width: calc(100% + 15px) !important;}
.propanel .option-alias {float: left;line-height: 36px;width: 70px;}
.propanel .sp-replacer {padding: 7px !important;border: solid 1px #dddee1 !important;border-radius: 4px !important;}
.propanel .sp-replacer:hover {border-color: #2d8cf0 !important;}
.propanel .sp-replacer.sp-active {border-color: #2d8cf0 !important;}
.propanel .form-group .control-label {display: inline-block;line-height: 36px;}
.propanel .tex-left {text-align: left;}
.propanel .tex-width {width: 90px;}
.propanel .con-width {width: 200px;}
.propanel .form-group {margin-bottom: 10px;}
.propanel .form-group.MarginSet .MarginSetIpt {width: 90px;padding-left: 20px;position: relative;}
.propanel .form-group.MarginSet .MarginSetIpt:after {position: absolute;display: block;line-height: 34px;left: 8px;font-size: 12px;top: 0;color: rgb(220,220,220);}
.propanel .form-group.MarginSet .MarginSetIpt:first-child {border-bottom-left-radius: 0;border-bottom-right-radius: 0;border-top-right-radius: 0;}
.propanel .form-group.MarginSet .MarginSetIpt:first-child:after {content: '上';}
.propanel .form-group.MarginSet .MarginSetIpt:nth-child(2) {border-bottom-left-radius: 0;border-top-left-radius: 0;border-bottom-right-radius: 0;}
.propanel .form-group.MarginSet .MarginSetIpt:nth-child(2):after {content: '右';}
.propanel .form-group.MarginSet .MarginSetIpt.third {border-top-left-radius: 0;border-top-right-radius: 0;border-bottom-right-radius: 0;}
.propanel .form-group.MarginSet .MarginSetIpt.third:after {content: '下';}
.propanel .form-group.MarginSet .MarginSetIpt:last-child {border-top-left-radius: 0;border-bottom-left-radius: 0;border-top-right-radius: 0;}
.propanel .form-group.MarginSet .MarginSetIpt:last-child:after {content: '左';}
.propanel .form-group.double-form-group {float: left;margin-right: 15px;}
.propanel .form-group.double-form-group .control-label {width: 60px;}
.propanel .form-group.double-form-group .col-sm {width: 70px;}
.propanel .form-group .bg-container {width: 100px;height: 100px;border-radius: 5px;border: 1px solid #e9e9e9;}
.propanel .form-group .control-label {display: inline-block;line-height: 36px;}
.propanel .form-group .col-sm {float: left;}
.propanel .form-group .col-sm .ivu-switch {margin-top: 6px;}
.propanel .form-group .col-sm .ivu-switch.double_line {margin-right: 10px;}
.propanel .form-group .col-sm .ivu-switch.double_line p {padding-left: 5px;line-height: 25px;}
.propanel .form-group .col-sm .fontIcon {line-height: 36px;font-size: 20px;padding: 5px;cursor: pointer;}
.propanel .form-group .col-sm .fontIcon.on {color: #2d8cf0;}
.propanel .form-group .col-sm .fontIcon:first-child {margin-left: 5px;}
.propanel .form-group .col-sm .IconalignSet {font-size: 16px;line-height: 34px;}
.propanel .form-group .col-sm .position-set-block {margin-top: 7px;}
.propanel .form-group .col-sm .position-set-block span {position: relative;display: inline-block;width: 16px;height: 16px;border: 1px solid #d5d5d5;cursor: pointer;margin-right: 4px;margin-bottom: 2px;border-radius: 50%;}
.propanel .form-group .col-sm .position-set-block span .mark {position: absolute;left: 2px;top: 2px;width: 10px;height: 10px;text-align: center;border-radius: 50%;background-color: #2d8cf0;display: none;}													
.propanel .form-group .col-sm .position-set-block span.on .mark {display: block;background-color: #2d8cf0;}
.propanel .form-group .col-sm.bg-col-sm {margin-left: 35px;width: 100px;text-align: center;}
.propanel .form-group .col-sm.bg-col-sm .bg-col-sm-btn {margin: 5px 0;}
.propanel .form-group .col-sm .form-control {width: 260px;}
.propanel .form-group .col-sm .sub-row {margin-bottom: 5px;}
.propanel .form-group .col-sm .sub-row label {display: inline-block;height: 32px;line-height: 32px;margin-right: 5px;}
.propanel .form-group .check-tip {line-height: 36px;margin-left: 10px;color: #a0a0a0;}
.propanel .dig-btn {margin-right: 20px;text-align: right;}
.propanel .box-main .box-form {padding: 15px;background-color: #fafafa;border-radius: 4px;border: 1px solid #dddee1;}
.propanel .box-main .box-form.sub-box-form {margin-top: 10px;}
.propanel .set_box .form-group.form-sort .col-sm .ivu-radio-group {width: 200px;}
.propanel .set_box .form-group.form-sort .col-sm .ivu-radio-group .ivu-radio-wrapper {width: 100px;box-sizing: border-box;text-align: center;}
.propanel .form-group .ivu-radio-wrapper {font-size: 14px;}
.propanel .propbgrepeat .ivu-radio-group .ivu-radio-wrapper.t1 {border-bottom-left-radius: 0;}
.propanel .propbgrepeat .ivu-radio-group .ivu-radio-wrapper.t2 {border-top-right-radius: 4px;}
.propanel .propbgrepeat .ivu-radio-group .ivu-radio-wrapper.t3 {border-top: 0;border-left: 1px solid #d7dde4;border-bottom-left-radius: 4px;}
.propanel .propbgrepeat .ivu-radio-group .ivu-radio-wrapper.t3.ivu-radio-wrapper-checked {border-left: none;border-top: 1px solid #2d8cf0;}
.propanel .propbgrepeat .ivu-radio-group .ivu-radio-wrapper.t4 {border-top: 0;border-top-right-radius: 0;border-bottom-right-radius: 4px;}
.propanel .propbgrepeat .ivu-radio-group .ivu-radio-wrapper.t4.ivu-radio-wrapper-checked {border-top: 1px solid #2d8cf0;}
</style>


// WEBPACK FOOTER //
// property.vue?22078b14